var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52734 10.4316C3.52734 14.1934 6.58594 17.252 10.3477 17.252C11.8945 17.252 13.3008 16.7334 14.4434 15.8721L19.0225 20.46C19.1807 20.6182 19.4004 20.7061 19.6201 20.7061C20.1299 20.7061 20.4639 20.3193 20.4639 19.8535C20.4639 19.625 20.376 19.4141 20.2266 19.2559L15.665 14.6855C16.6055 13.5166 17.168 12.04 17.168 10.4316C17.168 6.66992 14.1094 3.61133 10.3477 3.61133C6.58594 3.61133 3.52734 6.66992 3.52734 10.4316ZM4.66992 10.4316C4.66992 7.30273 7.21875 4.75391 10.3477 4.75391C13.4766 4.75391 16.0254 7.30273 16.0254 10.4316C16.0254 13.5605 13.4766 16.1094 10.3477 16.1094C7.21875 16.1094 4.66992 13.5605 4.66992 10.4316Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.fe138c91fa5ef6306644f702357311ed.svg";
export { ForwardRef as ReactComponent };